module.exports = __webpack_public_path__ + "static/media/beetroot.736d9e96.svg";